import { ArrowRight } from 'lucide-react';
import Img1 from "../../Images/Hero.jpg";
import Img3 from "../../Images/research.jpg";
import Img6 from "../../Images/research3.jpg";
import researchImg from "../../Images/Capacity.jpg";
import { useNavigate } from "react-router-dom";



// // pages/Home.jsx - Full Landing Page with DevLearn Palette
// import { ArrowRight } from 'lucide-react';
// import Img1 from "../../Images/Hero.jpg";
// import Img2 from "../../Images/Capacity.jpg";
// import Img3 from "../../Images/research.jpg";
// import Img4 from "../../Images/research5.jpg";
// import Img5 from "../../Images/research2.jpg";
// import Img6 from "../../Images/research3.jpg";
// import Img7 from "../../Images/research4.jpg";
// import researchImg from "../../Images/Capacity.jpg";
// // import merlImg from "../Images/research5.jpg";
// // import capacityImg from "../Images/research2.jpg";


import '../../index.css';

const Home = () => {

  const navigate = useNavigate();


  return (
    <>
      {/* Hero */}
      <section
  className="hero"
       style={{
   backgroundImage: `
  linear-gradient(
    rgba(42, 15, 29, 0.75),
    rgba(42, 15, 29, 0.75)
  ),
  url(${Img1})
`
,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
  }}
>
  <div style={{ position: 'relative', zIndex: 1 }}>
    <h1 style={{color: 'white'}}>Measuring What Matters. Empowering Change.</h1>
    <p >
      DevLearn Impact Research is a consulting firm registered as a private limited company. We provide technical and advisory services in monitoring, evaluation, research, project management, and capacity building. Our team comprises experienced and passionate development professionals committed to delivering high-quality, evidence-based solutions. 

    </p>
    <div className="hero-buttons">
      <a href="/services" className="btn btn-primary">
        Explore Our Services <ArrowRight />
      </a>
      <a href="/sectors" style={{color: 'white'}} className="btn btn-secondary">
        Thematic Focus Areas
      </a>
    </div>
  </div>
</section>

      {/* <section
        className="hero"
          style={{
            backgroundImage: `
              linear-gradient(
                rgba(0, 0, 0, 0.55),
                rgba(0, 0, 0, 0.55)
              ),
              url(${Img1})
            `,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            position: 'relative',
          }}

      >
        <div style={{ zIndex: 2, position: 'relative' }}>
          <h1>Measuring What Matters, Empowering Change</h1>
          <p>
            DevLearn Impact Research Ltd empowers communities through evidence-driven development solutions.
            As a Zambian consulting firm registered in June 2025, we deliver high-quality MERL, research, and
            capacity-building services to governments, NGOs, donors, and communities—fostering inclusive,
            sustainable transformation.
          </p>
          <div className="hero-buttons">
            <a href="/services" className="btn btn-primary">
              Explore Our Services <ArrowRight />
            </a>
            <a href="/sectors" className="btn btn-secondary">
              Thematic Focus Areas
            </a>
          </div>
        </div>
        <div
          style={{
            position: 'absolute',
            top: 0, left: 0, right: 0, bottom: 0,
            // background: 'rgba(255,255,255,0.3)',
             background: `url(${Img1}) center/cover no-repeat`,
            //background: 'rgba(255,255,255,0.3)',
            zIndex: 1,
          }}
        />
      </section> */}

      {/* Recognition */}
      <section className="section text-center recognition">
        <div className="container">
          <h2>Trusted by Governments, NGOs, Donors & Community Organizations</h2>
          <div className="badge"></div>
        </div>
      </section>

      {/* Hold the Hype */}
      <section className="hold-hype text-center">
        <div className="container">
          <h2>
            Evidence-Led Processes for Locally Owned Change.<br />Transforming Systems, Improving Lives.
          </h2>
          <p>Guided by integrity, collaboration, excellence, innovation, inclusion, evidence, and community empowerment.</p>
        </div>
      </section>

      {/* Capabilities / Services */}

      <section className="section capabilities">
  <div className="container text-center">
    <h2 className="section-title">
      Our Services: Rigorous, Context-Driven Solutions
    </h2>

    <div className="cap-grid">

      <section
        className="cap-card"
        onClick={() => navigate("/services/applied-research")}
        role="button"
        tabIndex={0}
      >
        <div
          className="cap-image"
          style={{
            backgroundImage: `
              linear-gradient(rgba(0,0,0,0.25), rgba(0,0,0,0.25)),
              url(${Img6})
            `,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        />
        <h3>Applied Research & Policy Analysis</h3>
        <p>
          Rigorous mixed-methods studies, impact evaluations, and data analytics
          to inform policy and systems thinking.
        </p>
      </section>

      <section
        className="cap-card"
        onClick={() => navigate("/services/merl")}
        role="button"
        tabIndex={0}
      >
        <div
          className="cap-image"
          style={{
            backgroundImage: `
              linear-gradient(rgba(0,0,0,0.25), rgba(0,0,0,0.25)),
              url(${Img3})
            `,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        />
        <h3>Monitoring, Evaluation, Research & Learning (MERL)</h3>
        <p>
          Frameworks for learning and accountability, with predictive analytics
          and real-time monitoring.
        </p>
      </section>

      <section
        className="cap-card"
        onClick={() => navigate("/services/implementation-research")}
        role="button"
        tabIndex={0}
      >
        <div
          className="cap-image"
          style={{
            backgroundImage: `
              linear-gradient(rgba(0,0,0,0.25), rgba(0,0,0,0.25)),
              url(${researchImg})
            `,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        />
        <h3>Institutional & Capacity Development</h3>
        <p>
          Tailored training in MERL tools (STATA, R, KoboToolbox) and systems
          reviews for sustainable change.
        </p>
      </section>

    </div>

    <div style={{ marginTop: "60px" }}>
      <a href="/services" className="btn btn-primary">
        View All Services
      </a>
    </div>
  </div>
</section>

   

      {/* Stats */}
      <section className="stats text-center">
        <div className="stats-grid">
          <div>
            <div className="stat-number">5+</div>
            <div className="stat-label">Years Combined Expertise</div>
          </div>
          <div>
            <div className="stat-number">11</div>
            <div className="stat-label">Thematic Focus Areas</div>
          </div>
          <div>
            <div className="stat-number">20+</div>
            <div className="stat-label">Affiliated Experts</div>
          </div>
          <div>
            <div className="stat-number">1</div>
            <div className="stat-label">Ongoing Project (2025)</div>
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="final-cta text-center">
        <div className="container">
          <h2>
            Ready to Drive Evidence-Based Change?<br />Partner with DevLearn for Sustainable Impact.
          </h2>
          <a href="/contact" className="btn btn-primary">
            Get In Touch <ArrowRight size={28} />
          </a>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container footer-grid">
          <div className="footer-column">
            <div className="footer-logo">DevLearn Impact Research Ltd</div>
            <p>Plot No. 3788/A, Avondale Road, Lusaka</p>
            <p>+260 973 902 981 / +260 978 341 825</p>
            <p>info@devlearnimpact.com</p>
          </div>
          <div className="footer-column">
            <h4>Services</h4>
            <ul>
              <li><a href="/services">Applied Research</a></li>
              <li><a href="/services">MERL Frameworks</a></li>
              <li><a href="/services">Capacity Building</a></li>
            </ul>
          </div>
          <div className="footer-column">
            <h4>Thematic Areas</h4>
            <ul>
              <li><a href="/sectors">Education & Health</a></li>
              <li><a href="/sectors">Governance & Climate</a></li>
              <li><a href="/sectors">Economic Inclusion</a></li>
            </ul>
          </div>
          <div className="footer-column">
            <h4>Company</h4>
            <ul>
              <li><a href="/about">About</a></li>
              <li><a href="/team">Team</a></li>
              <li><a href="/case-studies">Projects</a></li>
            </ul>
          </div>
          <div className="footer-column">
            <h4>Connect</h4>
            <ul>
              <li><a href="https://www.linkedin.com/company/devlearn-impact-research/">LinkedIn</a></li>
              <li><a href="https://www.facebook.com/share/1AS3Ahfsy7/">Facebook</a></li>
            </ul>
          </div>
        </div>

        <div className="copyright">
          © 2026 DevLearn Impact Research Ltd. All rights reserved. Registered in Zambia, June 28, 2025.
        </div>
      </footer>
    </>
  );
};

export default Home;




// // pages/Home.jsx - Landing page updated with DevLearn brand colors & fonts
// import { ArrowRight } from 'lucide-react';
// import '../../index.css'; // Ensure Poppins is imported globally

// const Home = () => {
//   return (
//     <>
//       {/* Hero */}
//       <section
//         className="hero"
//         style={{
//           background: 'linear-gradient(180deg, #FBB040 0%, #ffffff 100%)', // Yellow tint for brand
//           fontFamily: 'Poppins, sans-serif',
//         }}
//       >
//         <div>
//           <h1 style={{ color: '#9E1F63' }}>Measuring What Matters, Empowering Change</h1>
//           <p style={{ color: '#BA477C' }}>
//             DevLearn Impact Research Ltd empowers communities through evidence-driven development solutions. 
//             As a Zambian consulting firm registered in June 2025, we deliver high-quality MERL, research, and 
//             capacity-building services to governments, NGOs, donors, and communities—fostering inclusive, 
//             sustainable transformation.
//           </p>
//           <div className="hero-buttons">
//             <a
//               href="/services"
//               className="btn btn-primary"
//               style={{ background: '#9E1F63', color: '#fff' }} // Primary Purple
//             >
//               Explore Our Services <ArrowRight />
//             </a>
//             <a
//               href="/sectors"
//               className="btn btn-secondary"
//               style={{ background: '#F7941D', color: '#fff' }} // Orange
//             >
//               Thematic Focus Areas
//             </a>
//           </div>
//         </div>
//       </section>

//       {/* Recognition */}
//       <section className="section text-center recognition">
//         <div className="container">
//           <h2 style={{ color: '#9E1F63' }}>
//             Trusted by Governments, NGOs, Donors & Community Organizations
//           </h2>
//           <div
//             className="badge"
//             style={{ background: '#FBB040', borderColor: '#F7941D' }} // Yellow & Orange accents
//           ></div>
//         </div>
//       </section>

//       {/* Core Message */}
//       <section className="hold-hype text-center" style={{ background: '#FBB040' }}>
//         <div className="container">
//           <h2 style={{ color: '#9E1F63' }}>
//             Evidence-Led Processes for Locally Owned Change.<br />Transforming Systems, Improving Lives.
//           </h2>
//           <p style={{ color: '#BA477C' }}>
//             Guided by integrity, collaboration, excellence, innovation, inclusion, evidence, and community empowerment.
//           </p>
//         </div>
//       </section>

//       {/* Capabilities */}
//       <section className="section capabilities">
//         <div className="container text-center">
//           <h2 style={{ fontSize: '52px', marginBottom: '100px', color: '#9E1F63' }}>
//             Our Services: Rigorous, Context-Driven Solutions
//           </h2>
//           <div className="cap-grid">
//             {[
//               {
//                 title: 'Applied Research & Policy Analysis',
//                 desc: 'Rigorous mixed-methods studies, impact evaluations, and data analytics to inform policy and systems thinking.',
//               },
//               {
//                 title: 'Monitoring, Evaluation, Research & Learning (MERL)',
//                 desc: 'Frameworks for learning and accountability, with predictive analytics and real-time monitoring.',
//               },
//               {
//                 title: 'Institutional & Capacity Development',
//                 desc: 'Tailored training in MERL tools (STATA, R, KoboToolbox) and systems reviews for sustainable change.',
//               },
//             ].map((cap, idx) => (
//               <div
//                 key={idx}
//                 className="cap-card"
//                 style={{ borderTop: '4px solid #9E1F63' }} // Primary Purple accent
//               >
//                 <div
//                   className="cap-image"
//                   style={{ background: '#FBB040', borderColor: '#F7941D' }} // Yellow bg + Orange border
//                 ></div>
//                 <h3 style={{ color: '#9E1F63' }}>{cap.title}</h3>
//                 <p style={{ color: '#BA477C' }}>{cap.desc}</p>
//               </div>
//             ))}
//           </div>
//           <div style={{ marginTop: '60px' }}>
//             <a
//               href="/services"
//               className="btn btn-primary"
//               style={{ background: '#F7941D', color: '#fff' }} // Orange
//             >
//               View All Services
//             </a>
//           </div>
//         </div>
//       </section>

//       {/* Stats */}
//       <section className="stats text-center" style={{ background: '#9E1F63', color: '#fff' }}>
//         <div className="stats-grid">
//           {[
//             { num: '5+', label: 'Years Combined Expertise' },
//             { num: '11', label: 'Thematic Focus Areas' },
//             { num: '20+', label: 'Affiliated Experts' },
//             { num: '1', label: 'Ongoing Project (2025)' },
//           ].map((stat, idx) => (
//             <div key={idx}>
//               <div className="stat-number" style={{ color: '#FBB040' }}>{stat.num}</div> {/* Yellow */}
//               <div className="stat-label">{stat.label}</div>
//             </div>
//           ))}
//         </div>
//       </section>

//       {/* Final CTA */}
//       <section className="final-cta text-center" style={{ background: '#9E1F63', color: '#fff' }}>
//         <div className="container">
//           <h2>
//             Ready to Drive Evidence-Based Change?<br />Partner with DevLearn for Sustainable Impact.
//           </h2>
//           <a
//             href="/contact"
//             className="btn btn-primary"
//             style={{ background: '#FBB040', color: '#9E1F63' }} // Yellow button with purple text
//           >
//             Get In Touch <ArrowRight size={28} />
//           </a>
//         </div>
//       </section>

//       {/* Footer */}
//       <footer className="footer" style={{ background: '#111827', fontFamily: 'Poppins, sans-serif' }}>
//         <div className="footer-grid">
//           <div>
//             <div className="footer-logo" style={{ color: '#FBB040' }}>DevLearn Impact Research Ltd</div> {/* Yellow */}
//             <p style={{ color: '#BA477C' }}>Plot No. 3788/A, Avondale Road, Lusaka</p>
//             <p style={{ color: '#BA477C' }}>+260 973 902 981 / +260 978 341 825</p>
//             <p style={{ color: '#BA477C' }}>info@devlearnimpact.com</p>
//           </div>
//           <div>
//             <h4 style={{ color: '#FBB040' }}>Services</h4>
//             <ul>
//               <li><a href="/services" style={{ color: '#BA477C' }}>Applied Research</a></li>
//               <li><a href="/services" style={{ color: '#BA477C' }}>MERL Frameworks</a></li>
//               <li><a href="/services" style={{ color: '#BA477C' }}>Capacity Building</a></li>
//             </ul>
//           </div>
//           <div>
//             <h4 style={{ color: '#FBB040' }}>Thematic Areas</h4>
//             <ul>
//               <li><a href="/sectors" style={{ color: '#BA477C' }}>Education & Health</a></li>
//               <li><a href="/sectors" style={{ color: '#BA477C' }}>Governance & Climate</a></li>
//               <li><a href="/sectors" style={{ color: '#BA477C' }}>Economic Inclusion</a></li>
//             </ul>
//           </div>
//           <div>
//             <h4 style={{ color: '#FBB040' }}>Company</h4>
//             <ul>
//               <li><a href="/about" style={{ color: '#BA477C' }}>About</a></li>
//               <li><a href="/team" style={{ color: '#BA477C' }}>Team</a></li>
//               <li><a href="/case-studies" style={{ color: '#BA477C' }}>Projects</a></li>
//             </ul>
//           </div>
//           <div>
//             <h4 style={{ color: '#FBB040' }}>Connect</h4>
//             <ul>
//               <li><a href="https://www.linkedin.com/company/devlearn-impact-research/" style={{ color: '#BA477C' }}>LinkedIn</a></li>
//               <li><a href="https://www.facebook.com/share/1AS3Ahfsy7/" style={{ color: '#BA477C' }}>Facebook</a></li>
//             </ul>
//           </div>
//         </div>
//         <div className="copyright" style={{ color: '#9CA3AF' }}>
//           © 2025 DevLearn Impact Research Ltd. All rights reserved. Registered in Zambia, June 28, 2025.
//         </div>
//       </footer>
//     </>
//   );
// };

// export default Home;


// // pages/Home.jsx - Landing page for DevLearn Impact Research Ltd (adapted with PDF content and new color palette)
// import { ArrowRight } from 'lucide-react';
// import '../../index.css'; // Shared global styles (updated with new palette below)

// const Home = () => {
//   return (
//     <>
//       {/* Hero */}
//       <section className="hero" style={{ background: 'linear-gradient(180deg, #f0f8ff 0%, #ffffff 100%)' }}> {/* Subtle blue tint for new palette */}
//         <div>
//           <h1>Measuring What Matters, Empowering Change</h1>
//           <p>
//             DevLearn Impact Research Ltd empowers communities through evidence-driven development solutions. As a Zambian consulting firm registered in June 2025, we deliver high-quality MERL, research, and capacity-building services to governments, NGOs, donors, and communities—fostering inclusive, sustainable transformation.
//           </p>
//           <div className="hero-buttons">
//             <a href="/services" className="btn btn-primary">
//               Explore Our Services <ArrowRight />
//             </a>
//             <a href="/sectors" className="btn btn-secondary">
//               Thematic Focus Areas
//             </a>
//           </div>
//         </div>
//       </section>

//       {/* Recognition - Trusted By */}
//       <section className="section text-center recognition">
//         <div className="container">
//           <h2>Trusted by Governments, NGOs, Donors & Community Organizations</h2>
//           <div className="badge" style={{ background: '#E5E7EB', borderColor: '#D1D5DB' }}></div> {/* Neutral gray for new palette */}
//         </div>
//       </section>

//       {/* Hold the Hype - Core Message */}
//       <section className="hold-hype text-center" style={{ background: '#F0F9FF' }}> {/* Light blue-gray */}
//         <div className="container">
//           <h2>
//             Evidence-Led Processes for Locally Owned Change.<br />Transforming Systems, Improving Lives.
//           </h2>
//           <p>Guided by integrity, collaboration, excellence, innovation, inclusion, evidence, and community empowerment.</p>
//         </div>
//       </section>

//       {/* Capabilities - Adapted to Services from PDF */}
//       <section className="section capabilities">
//         <div className="container text-center">
//           <h2 style={{ fontSize: '52px', marginBottom: '100px', color: '#1E3A8A' }}>Our Services: Rigorous, Context-Driven Solutions</h2> {/* Navy header */}
//           <div className="cap-grid">
//             <div className="cap-card" style={{ borderTop: '4px solid #1E3A8A' }}> {/* Navy accent */}
//               <div className="cap-image" style={{ background: '#F0F9FF', borderColor: '#0D9488' }}></div> {/* Teal border */}
//               <h3>Applied Research & Policy Analysis</h3>
//               <p>
//                 Rigorous mixed-methods studies, impact evaluations, and data analytics to inform policy and systems thinking.
//               </p>
//             </div>
//             <div className="cap-card" style={{ borderTop: '4px solid #1E3A8A' }}>
//               <div className="cap-image" style={{ background: '#F0F9FF', borderColor: '#0D9488' }}></div>
//               <h3>Monitoring, Evaluation, Research & Learning (MERL)</h3>
//               <p>
//                 Frameworks for learning and accountability, with predictive analytics and real-time monitoring.
//               </p>
//             </div>
//             <div className="cap-card" style={{ borderTop: '4px solid #1E3A8A' }}>
//               <div className="cap-image" style={{ background: '#F0F9FF', borderColor: '#0D9488' }}></div>
//               <h3>Institutional & Capacity Development</h3>
//               <p>
//                 Tailored training in MERL tools (STATA, R, KoboToolbox) and systems reviews for sustainable change.
//               </p>
//             </div>
//           </div>
//           <div style={{ marginTop: '60px' }}>
//             <a href="/services" className="btn btn-primary" style={{ background: '#0D9488', color: '#fff' }}>View All Services</a> {/* Teal button */}
//           </div>
//         </div>
//       </section>

//       {/* Stats - From PDF inferences + site style */}
//       <section className="stats text-center" style={{ background: '#1E3A8A', color: '#fff' }}> {/* Navy bg */}
//         <div className="stats-grid">
//           <div>
//             <div className="stat-number" style={{ color: '#0D9488' }}>5+</div> {/* Teal numbers */}
//             <div className="stat-label">Years Combined Expertise</div>
//           </div>
//           <div>
//             <div className="stat-number" style={{ color: '#0D9488' }}>11</div>
//             <div className="stat-label">Thematic Focus Areas</div>
//           </div>
//           <div>
//             <div className="stat-number" style={{ color: '#0D9488' }}>20+</div>
//             <div className="stat-label">Affiliated Experts</div>
//           </div>
//           <div>
//             <div className="stat-number" style={{ color: '#0D9488' }}>1</div>
//             <div className="stat-label">Ongoing Project (2025)</div>
//           </div>
//         </div>
//       </section>

//       {/* Final CTA - Vision/Mission Tie-In */}
//       <section className="final-cta text-center" style={{ background: '#1E3A8A', color: '#fff' }}> {/* Navy bg */}
//         <div className="container">
//           <h2>
//             Ready to Drive Evidence-Based Change?<br />Partner with DevLearn for Sustainable Impact.
//           </h2>
//           <a href="/contact" className="btn btn-primary" style={{ background: '#fff', color: '#1E3A8A' }}>
//             Get In Touch <ArrowRight size={28} />
//           </a>
//         </div>
//       </section>

//       {/* Footer - Updated with DevLearn Contacts */}
//       <footer className="footer" style={{ background: '#111827' }}> {/* Darker navy-gray */}
//         <div className="footer-grid">
//           <div>
//             <div className="footer-logo" style={{ color: '#0D9488' }}>DevLearn Impact Research Ltd</div> {/* Teal logo */}
//             <p>Plot No. 3788/A, Avondale Road, Lusaka</p>
//             <p>+260 973 902 981 / +260 978 341 825</p>
//             <p>info@devlearnimpact.com</p>
//           </div>
//           <div>
//             <h4 style={{ color: '#fff' }}>Services</h4>
//             <ul>
//               <li><a href="/services">Applied Research</a></li>
//               <li><a href="/services">MERL Frameworks</a></li>
//               <li><a href="/services">Capacity Building</a></li>
//             </ul>
//           </div>
//           <div>
//             <h4 style={{ color: '#fff' }}>Thematic Areas</h4>
//             <ul>
//               <li><a href="/sectors">Education & Health</a></li>
//               <li><a href="/sectors">Governance & Climate</a></li>
//               <li><a href="/sectors">Economic Inclusion</a></li>
//             </ul>
//           </div>
//           <div>
//             <h4 style={{ color: '#fff' }}>Company</h4>
//             <ul>
//               <li><a href="/about">About</a></li>
//               <li><a href="/team">Team</a></li>
//               <li><a href="/case-studies">Projects</a></li>
//             </ul>
//           </div>
//           <div>
//             <h4 style={{ color: '#fff' }}>Connect</h4>
//             <ul>
//               <li><a href="https://www.linkedin.com/company/devlearn-impact-research/">LinkedIn</a></li>
//               <li><a href="https://www.facebook.com/share/1AS3Ahfsy7/">Facebook</a></li>
//             </ul>
//           </div>
//         </div>
//         <div className="copyright" style={{ color: '#9CA3AF' }}>
//           © 2025 DevLearn Impact Research Ltd. All rights reserved. Registered in Zambia, June 28, 2025.
//         </div>
//       </footer>
//     </>
//   );
// };

// export default Home;

// // pages/Home.jsx - Landing page content (extracted from original App)
// import { ArrowRight } from 'lucide-react';
// import '../../index.css'; // Import shared global styles

// const Home = () => {
//   return (
//     <>
//       {/* Hero */}
//       <section className="hero">
//         <div>
//           <h1>Turning Data Into Decisions That Matter</h1>
//           <p>
//             We help organisations uncover insights, evaluate impact, and design
//             strategies backed by evidence. Precise research. Clear direction.
//             Real results.
//           </p>
//           <div className="hero-buttons">
//             <a href="#" className="btn btn-primary">
//               Start a project <ArrowRight />
//             </a>
//             <a href="#" className="btn btn-secondary">
//               View our studies
//             </a>
//           </div>
//         </div>
//       </section>

//       {/* Recognition */}
//       <section className="section text-center recognition">
//         <div className="container">
//           <h2>Trusted by Governments, NGOs & Leading Institutions</h2>
//           <div className="badge"></div>
//         </div>
//       </section>

//       {/* Hold the hype */}
//       <section className="hold-hype text-center">
//         <div className="container">
//           <h2>
//             Research that goes beyond numbers.<br />Insight that drives change.
//           </h2>
//           <p>Evidence, hold the guesswork.</p>
//         </div>
//       </section>

//       {/* Capabilities */}
//       <section className="section capabilities">
//         <div className="container text-center">
//           <h2 style={{ fontSize: '52px', marginBottom: '100px' }}>
//             Why organisations trust us
//           </h2>
//           <div className="cap-grid">
//             <div className="cap-card">
//               <div className="cap-image"></div>
//               <h3>Expert-Led Research</h3>
//               <p>
//                 From survey design to fieldwork and analysis, we deliver
//                 end-to-end research solutions built on global standards.
//               </p>
//             </div>
//             <div className="cap-card">
//               <div className="cap-image"></div>
//               <h3>Sector-Specific Insights</h3>
//               <p>
//                 Deep experience across education, health, finance, agriculture,
//                 and public policy — with contextualised insights.
//               </p>
//             </div>
//             <div className="cap-card">
//               <div className="cap-image"></div>
//               <h3>Strategic Impact</h3>
//               <p>
//                 Our findings translate directly into decisions, policy,
//                 innovation, and actionable recommendations.
//               </p>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Stats */}
//       <section className="stats text-center">
//         <div className="stats-grid">
//           <div>
//             <div className="stat-number">500+</div>
//             <div className="stat-label">Completed Studies</div>
//           </div>
//           <div>
//             <div className="stat-number">20+</div>
//             <div className="stat-label">Research Countries</div>
//           </div>
//           <div>
//             <div className="stat-number">150+</div>
//             <div className="stat-label">Institutional Clients</div>
//           </div>
//           <div>
//             <div className="stat-number">98%</div>
//             <div className="stat-label">Client Satisfaction</div>
//           </div>
//         </div>
//       </section>

//       {/* Final CTA */}
//       <section className="final-cta text-center">
//         <div className="container">
//           <h2>
//             Ready to understand what truly matters?<br />Let’s explore it together.
//           </h2>
//           <a href="#" className="btn btn-primary">
//             Start the conversation <ArrowRight size={28} />
//           </a>
//         </div>
//       </section>

//       {/* Footer - Reused across pages for consistency */}
//       <footer className="footer">
//         <div className="footer-grid">
//           <div>
//             <div className="footer-logo">InSight Research</div>
//           </div>
//           <div>
//             <h4>Services</h4>
//             <ul>
//               <li><a href="#">Market Research</a></li>
//               <li><a href="#">Impact Evaluation</a></li>
//               <li><a href="#">Data Analytics</a></li>
//             </ul>
//           </div>
//           <div>
//             <h4>Sectors</h4>
//             <ul>
//               <li><a href="#">Education</a></li>
//               <li><a href="#">Public Health</a></li>
//               <li><a href="#">Finance & Development</a></li>
//             </ul>
//           </div>
//           <div>
//             <h4>Company</h4>
//             <ul>
//               <li><a href="#">About</a></li>
//               <li><a href="#">Team</a></li>
//               <li><a href="#">Reports</a></li>
//             </ul>
//           </div>
//           <div>
//             <h4>Contact</h4>
//             <ul>
//               <li><a href="#">hello@insightresearch.com</a></li>
//               <li><a href="#">Locations</a></li>
//             </ul>
//           </div>
//         </div>
//         <div className="copyright">
//           © 2025 InSight Research. All rights reserved.
//         </div>
//       </footer>
//     </>
//   );
// };

// export default Home;